import { CustomerDisplayConfigurationDTO, Res, SaleDTO, TicketDTO, TicketLineDTO } from 'core/api';
import { showScreen, Screen } from './Screen';
import { Display } from './Display';

let screen: Screen | null = null;

const display: Display & { show: (configuration: CustomerDisplayConfigurationDTO) => Promise<void> } = {

	async clear(): Promise<void> {
		screen?.setContent({ type: 'Message', message: '' });
	},

	async show(configuration: CustomerDisplayConfigurationDTO): Promise<void> {
		screen = await showScreen(configuration);
	},

	async displayTotal(amount: number): Promise<void> {
		screen?.setContent({ type: 'Amount', amount });
	},

	async displayTicketTotal(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},

	async displayOffers(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},

	async displaySale(sale: SaleDTO): Promise<void> {
		screen?.setContent({ type: 'Sale', sale });
	},

	async displayNewLine(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		screen?.setContent({ type: 'TicketWithLine', ticket, line });
	},

	async displayExistingLine(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		screen?.setContent({ type: 'TicketWithLine', ticket, line });
	},

	async displayRemovedLine(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		if (line?.Product.ProductName)
			screen?.setContent({ type: 'TicketWithLine', ticket, line });
		else
			screen?.setContent({ type: 'Ticket', ticket });
	},

	async displayLineDiscountPercentage(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		screen?.setContent({ type: 'TicketWithLine', ticket, line });
	},

	async displayLineCashDiscount(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		screen?.setContent({ type: 'TicketWithLine', ticket, line });
	},

	async displayDiscounts(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},

	async displayClosedCashdrawer(): Promise<void> {
		screen?.setContent({ type: 'Message', message: Res.Const.CLOSED_CASHDRAWER_DISPLAY_LBL() });
	},

	async displayLineNote(ticket: TicketDTO, line: TicketLineDTO): Promise<void> {
		screen?.setContent({ type: 'TicketWithLine', ticket, line });
	},

	async displayWeight(kgs: number, pricePerKgs: number, total: number): Promise<void> {
		screen?.setContent({ type: 'Weight', kgs, pricePerKgs, total });
	},

	async displayCustomer(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},

	async displayPriceList(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},

	async displayServiceCharge(ticket: TicketDTO): Promise<void> {
		screen?.setContent({ type: 'Ticket', ticket });
	},
};

export default display;